module.exports = __webpack_public_path__ + "img/comm-error.f28048de.jpg";